var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCgiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 36,
    viewBox: "0 0 76 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    d: "M18.844 6.78848C17.3986 6.74892 15.96 6.99963 14.6133 7.52578C13.2665 8.05193 12.0389 8.84283 11.0032 9.8517C9.96741 10.8606 9.1445 12.0669 8.58311 13.3994C8.02173 14.7319 7.73328 16.1634 7.73482 17.6093C7.73482 24.1508 13.0831 28.4301 18.8846 28.4301C22.752 28.4301 26.4139 26.7023 29.5405 23.9453V32.0505C26.1236 34.0368 22.2599 35.1266 18.3087 35.2185C8.35218 35.2185 0 27.1133 0 17.6093C0 7.52931 8.39361 0 18.3501 0C22.2399 0.0639807 26.0706 0.962042 29.5836 2.63352V10.5738C25.92 8.14667 22.2175 6.78848 18.844 6.78848Z",
    fill: "#E31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M50.7294 35.2185C40.7315 35.2185 32.2559 27.4423 32.2559 17.6093C32.2559 7.69339 40.6495 0 51.1819 0C55.1265 0.0460275 59.0246 0.85651 62.6607 2.38657V10.2863C59.3277 8.35218 55.0493 6.82991 51.346 6.82991C49.8879 6.78714 48.4359 7.03391 47.0738 7.55593C45.7117 8.07795 44.4667 8.86486 43.4107 9.87115C42.3547 10.8774 41.5087 12.0831 40.9217 13.4185C40.3347 14.7538 40.0182 16.1923 39.9907 17.6507C39.9907 24.0315 45.2569 28.677 51.4694 28.677C52.8875 28.7241 54.3007 28.4862 55.6252 27.9776V21.5968H49.9903V14.8937H62.8678V32.7101C59.0435 34.3918 54.9071 35.2466 50.7294 35.2185Z",
    fill: "#E31937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M68.4629 34.5191V0.699387H75.7038V34.5191H68.4629Z",
    fill: "#E31937"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgiLogo);
export default __webpack_public_path__ + "static/media/cgi_logo.ad72b4d6dae3eb14c4343f0912f94054.svg";
export { ForwardRef as ReactComponent };